import { ITagAttribute } from '@interfaces/common.interface';
import Birthday from '@assets/images/tag-icons/birthday.svg';
import Tourist from '@assets/images/tag-icons/tourist.svg';

export enum ExclusiveGroup {
	ALL = 'ALL',
	BIRTHDAY = 'BIRTHDAY',
	TOURIST = 'TOURIST',
	KF_MEMBERSHIP = 'KF_MEMBERSHIP',
}

export enum WaysToRedeem {
	IN_STORE = 'IN_STORE',
	PROMO_CODE = 'PROMO_CODE',
	EXCLUSIVE_URL = 'EXCLUSIVE_URL',
}

export enum KFMemberTier {
	BASIC = 'K',
	SILVER = 'S',
	GOLD = 'G',
	PPS = 'Q',
	SOLITAIRE_PPS = 'T',
	LIFETIME_PPS = 'L',
}

export const PRIVILEGE_TAG_ATTRIBUTES = {
	IN_STORE: {
		text: 'Redeem In-Store',
		textColor: 'text-white',
		backgroundColor: 'bg-sia-blue',
	} as ITagAttribute,
	ONLINE: {
		text: 'Redeem Online',
		textColor: 'text-white',
		backgroundColor: 'bg-sia-blue',
	} as ITagAttribute,
	BIRTHDAY: {
		text: 'Birthday',
		textColor: 'text-white',
		icon: <Birthday />,
		backgroundColor: 'bg-purple',
		bannerText: 'Birthday Exclusive',
	} as ITagAttribute,
	TOURIST: {
		text: 'Tourist',
		textColor: 'text-white',
		icon: <Tourist />,
		gradientColor: {
			start: 'from-[#A93326]',
			end: 'to-[#EB008B]',
		},
		bannerText: 'Tourist Exclusive',
	} as ITagAttribute,
	PPS_CLUB: {
		text: 'PPS Club',
		textColor: 'text-white',
		gradientColor: {
			start: 'from-[#1937ED]',
			end: 'to-[#64C8FF]',
		},
		bannerText: 'PPS Club Exclusive',
	} as ITagAttribute,
	ELITE_MEMBER: {
		text: 'Elite Member',
		textColor: 'text-white',
		gradientColor: {
			start: 'from-[#1937ED]',
			end: 'to-[#64C8FF]',
		},
		bannerText: 'Elite Member',
	} as ITagAttribute,
};
